<!-- @if (detailData?.company?.is_subcontracting) {
  <div
    class="report-preview p-2 border-primary text-primary border border-2 rounded my-2 text-center fw-semibold bg-white"
  >
    {{ detailData?.company?.company_name }} is a Prime Contractor
  </div>
} -->
<div class="my-3">
  <button
    class="btn btn-danger btn-sm d-flex align-items-center gap-2"
    (click)="onEmailReport()"
  >
    Export <i class="fa-regular fa-file-pdf fs-4"></i>
  </button>
</div>
<div
  class="preview-report p-lg-5 p-2 report-preview shadow bg-white text-black"
>
  <!-- @if (eventsOutsideStatusTimeStamps?.length) {
    <div class="alert alert-warning text-center">
      WARNING: There are events occurring outside the onsite window.
    </div>
  } -->

  @if (detailData?.id) {
    @if (!detailData?.additional_info?.hide_header) {
      <div id="headerSection" class="header-container">
        <div class="subscriber_company_information_section">
          @if (!detailData?.additional_info?.hide_subscriber_header_details) {
            <div class="fw-bold">
              {{ job_details?.subscriber_info?.name }}
            </div>
            <div>{{ job_details?.subscriber_info?.address }}</div>
            <div>{{ job_details?.subscriber_info?.city }}</div>
            @if (job_details?.subscriber_info?.mobile_number) {
              <div>Ph: {{ job_details?.subscriber_info?.mobile_number }}</div>
            }
            <div>{{ job_details?.subscriber_info?.email }}</div>
          }
        </div>

        <div class="text-center">
          @if (job_details?.subscriber_info?.logo_url) {
            <img
              [ngClass]="largeView ? 'logo_img_large' : 'logo_img_mob'"
              alt="placeholder_logo"
              src="{{ job_details?.subscriber_info?.logo_url }}"
            />
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-1 px-3 uploadLogo text-center"
            >
              Update Logo
            </div>
          } @else {
            <div
              (click)="modifyLetterHeadLogo()"
              role="button"
              class="border border-1 rounded-2 opacity-50 py-4 px-3 uploadLogo text-center ms-2"
            >
              Upload Logo
            </div>
          }
        </div>
      </div>
    }
    <div class="report-type-heading">Job Completion Report</div>
    <!--CLIENT INFORMATION SECTION-->
    <div class="client_information_section mb-3">
      <div>{{ job_details?.client }}</div>
      @if (!detailData?.additional_info?.hide_client_detail) {
        @if (job_details?.custom_address) {
          <div class="gt-multi-line">{{ job_details?.custom_address }}</div>
        }
        <div>
          {{ job_details?.address }}
        </div>

        <div>
          {{ job_details?.city }}
        </div>
      }
    </div>
    <div class="patrol-table mt-3">
      @if (job_details?.time_zone && job_details?.time_zone_diff) {
        <div
          style="
            font-size: 10px;
            padding-bottom: 0.5rem;
            color: #333;
            font-weight: bold;
            font-style: italic;
          "
        >
          Timestamps shown in {{ job_details.time_zone }}
          {{ job_details.time_zone_diff }}
        </div>
      }
      <table style="width: 100%; max-width: 100%" class="responsive">
        @if (largeView) {
          <tr>
            <td class="cell-heading">Date</td>
            <td
              [attr.colspan]="
                (detailData?.status?.status_identity?.value == 9 ||
                  detailData?.sites?.[0]?.sub_biller?.id) &&
                !detailData?.additional_info?.hide_sub_biller
                  ? 1
                  : 3
              "
            >
              <div class="d-flex">
                {{ job_details?.report_date }}
              </div>
            </td>
            @if (
              (detailData?.status?.status_identity?.value == 9 ||
                detailData?.sites?.[0]?.sub_biller?.id) &&
              !detailData?.additional_info?.hide_sub_biller
            ) {
              <td class="cell-heading">Sub Biller</td>
              <td>
                <div class="d-flex">
                  {{ detailData?.sites?.[0]?.sub_biller?.company_name }}
                </div>
              </td>
            }
          </tr>
        } @else {
          <tr>
            <td class="cell-heading">Date</td>
            <td>
              <div class="d-flex">
                {{ job_details?.report_date }}
              </div>
            </td>
          </tr>
          @if (
            (detailData?.status?.status_identity?.value == 9 ||
              detailData?.sites?.[0]?.sub_biller?.id) &&
            !detailData?.additional_info?.hide_sub_biller
          ) {
            <tr>
              <td class="cell-heading">Sub Biller</td>
              <td>
                <div class="d-flex">
                  {{ detailData?.sites?.[0]?.sub_biller?.company_name }}
                </div>
              </td>
            </tr>
          }
        }
        @if (largeView) {
          @if (!detailData?.additional_info?.hide_docket_number) {
            <tr>
              <td class="cell-heading">Docket No.</td>
              <td
                [attr.colspan]="
                  [0, 5].includes(detailData?.service_type?.type_identity) &&
                  (detailData?.status?.status_identity?.value == 9 ||
                    job_details?.ext_job_id)
                    ? 1
                    : 3
                "
              >
                <div class="d-flex enable-text-select">
                  {{ job_details?.job_key }}
                  @if (job_details?.job_key) {
                    <span
                      (click)="copyContentToClipBoard(job_details?.job_key)"
                    >
                      <i
                        class="fa-regular fa-copy fs-5 text-secondary ms-3"
                      ></i>
                    </span>
                  }
                </div>
              </td>
              @if (
                [0, 5].includes(detailData?.service_type?.type_identity) &&
                (detailData?.status?.status_identity?.value == 9 ||
                  job_details?.ext_job_id)
              ) {
                <td class="cell-heading">Job No.</td>
                <td>
                  <div class="d-flex enable-text-select">
                    {{ job_details?.ext_job_id }}
                    @if (job_details?.ext_job_id) {
                      <span
                        (click)="
                          copyContentToClipBoard(job_details?.ext_job_id)
                        "
                      >
                        <i
                          class="fa-regular fa-copy fs-5 text-secondary ms-3"
                        ></i>
                      </span>
                    }
                  </div>
                </td>
              }
            </tr>
          }
          <tr>
            <td class="cell-heading">Job Type</td>
            <td
              [attr.colspan]="
                [0, 5].includes(detailData?.service_type?.type_identity) &&
                (detailData?.status?.status_identity?.value == 9 ||
                  job_details?.monitoring_company)
                  ? 1
                  : 3
              "
            >
              <div class="d-flex enable-text-select">
                @if (job_details?.response_type) {
                  {{ job_details?.type }} -
                  <span class="fw-semibold ms-1">
                    {{ job_details?.response_type }}</span
                  >
                } @else {
                  {{ job_details?.type }}
                }
              </div>
            </td>
            @if (
              [0, 5].includes(detailData?.service_type?.type_identity) &&
              (detailData?.status?.status_identity?.value == 9 ||
                job_details?.monitoring_company)
            ) {
              <td class="cell-heading">Monitoring Company</td>
              <td>
                <div class="d-flex">
                  {{ job_details?.monitoring_company }}
                </div>
              </td>
            }
          </tr>
        } @else {
          @if (!detailData?.additional_info?.hide_docket_number) {
            <tr>
              <td class="cell-heading">Docket No.</td>
              <td>
                <div class="d-flex">
                  <span class="enable-text-select">
                    {{ job_details?.job_key }}</span
                  >
                  <span (click)="copyContentToClipBoard(job_details?.job_key)">
                    <i class="fa-regular fa-copy fs-5 text-secondary ms-3"></i>
                  </span>
                </div>
              </td>
            </tr>
          }
          @if (
            [0, 5].includes(detailData?.service_type?.type_identity) &&
            (detailData?.status?.status_identity?.value == 9 ||
              job_details?.ext_job_id)
          ) {
            <tr>
              <td class="cell-heading">Job No.</td>
              <td>
                <div class="d-flex">
                  <span class="enable-text-select">
                    {{ job_details?.ext_job_id }}
                  </span>
                  @if (job_details?.ext_job_id) {
                    <span
                      (click)="copyContentToClipBoard(job_details?.ext_job_id)"
                    >
                      <i
                        class="fa-regular fa-copy fs-5 text-secondary ms-3"
                      ></i>
                    </span>
                  }
                </div>
              </td>
            </tr>
          }
          <tr>
            <td class="cell-heading">Job Type</td>

            <td>
              <div class="d-flex enable-text-select">
                {{ job_details?.type }}
                @if (job_details?.response_type) {
                  -
                  <span class="fw-semibold ms-1">
                    {{ job_details?.response_type }}</span
                  >
                }
              </div>
            </td>
          </tr>
          @if (
            [0, 5].includes(detailData?.service_type?.type_identity) &&
            (detailData?.status?.status_identity?.value == 9 ||
              job_details?.monitoring_company)
          ) {
            <tr>
              <td class="cell-heading">Monitoring Company</td>
              <td>
                {{ job_details?.monitoring_company }}
              </td>
            </tr>
          }
        }
        <tr>
          <td class="cell-heading">Location</td>
          @for (item of job_details?.site_address; track item) {
            <td colspan="3">
              <span class="fw-semibold me-2">{{ item?.site_name }}</span>
              <span class="enable-text-select">
                {{ item?.address }} {{ item?.city }}
              </span>
            </td>
          }
        </tr>
        @if (
          detailData?.roster_scheduler?.repeat_type &&
          !detailData?.additional_info?.hide_shift_info
        ) {
          <td class="cell-heading">Shift</td>
          <td colspan="3">
            <div class="d-flex">
              {{
                detailData?.roster_scheduler?.shiftStartDateTime
                  | customDate: "d MMM y HH:mm"
              }}
              -
              {{
                detailData?.roster_scheduler?.shiftEndDateTime
                  | customDate: "d MMM y HH:mm"
              }}
              [{{ detailData?.roster_scheduler?.shiftDuration }}]
            </div>
          </td>
        }
        @if (
          [0, 1, 5, 3, 6].includes(detailData?.service_type?.type_identity)
        ) {
          @for (item of statusTimeStamps; track item) {
            <tr>
              <td class="cell-heading">
                {{ item?.value }}
                @if (
                  item?.sortInfo &&
                  detailData?.status?.status_identity?.value == 9
                ) {
                  <div class="float-end">
                    @if (item?.sortInfo === "up") {
                      <span>
                        <i class="fa-solid fa-arrow-up text-danger"></i
                      ></span>
                    } @else {
                      <span>
                        <i class="fa-solid fa-arrow-down text-danger"></i
                      ></span>
                    }
                  </div>
                }
              </td>
              <td colspan="3">
                <div class="status-change d-flex">
                  {{ item?.event_time | date: "dd MMM yyyy HH:mm" }}
                </div>
              </td>
            </tr>
          }
        }
        @if (
          detailData?.seal_info?.internal_check &&
          [0, 5].includes(detailData?.service_type?.type_identity)
        ) {
          <tr>
            <td colspan="6">
              <div class="d-flex">
                <div class="pe-2">
                  <dd class="gt-multi-line enable-text-select">
                    <div class="fw-semibold">
                      {{
                        detailData?.seal_info?.site_sealed
                          ? "Site Sealed"
                          : "Site Not Sealed"
                      }}
                    </div>
                    @if (
                      !detailData?.seal_info?.site_sealed &&
                      detailData?.seal_info?.uncleared_reason
                    ) {
                      Reason: {{ detailData?.seal_info?.uncleared_reason }}
                    }
                    @if (
                      detailData?.seal_info?.site_sealed &&
                      detailData?.seal_info?.cleared_by
                    ) {
                      Cleared By:
                      {{ detailData?.seal_info?.cleared_by }}
                    }
                  </dd>
                </div>
              </div>
            </td>
          </tr>
        }
        @if (
          detailData?.status?.status_identity?.value == 9 ||
          job_details?.additional_info
        ) {
          <tr>
            <td class="cell-heading line-height">Job Details</td>
            <td colspan="3">
              <div class="d-flex">
                <div class="pe-2">
                  <div class="gt-multi-line fs-6 enable-text-select">
                    {{ job_details?.additional_info }}
                  </div>
                </div>
                <div>
                  @if (job_details?.additional_info) {
                    <span
                      (click)="
                        copyContentToClipBoard(job_details?.additional_info)
                      "
                    >
                      <i
                        class="fa-regular fa-copy fs-5 text-secondary ms-3"
                      ></i>
                    </span>
                  }
                </div>
              </div>
            </td>
          </tr>
        }
      </table>
    </div>
    <!-- REPORT SUMMARY -->

    @if (summaryData?.length) {
      <div class="col-12 col-lg-2 fw-bold my-3 align-items-center">
        <div [ngClass]="!summaryData?.length ? 'opacity-50' : ''">
          Report Summary
        </div>
      </div>
      @if (largeView) {
        <div class="patrol-table mb-5">
          <table class="w-100">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Time</th>
                <th>Event</th>
                <th style="border-left: hidden"></th>
                @if (!detailData?.additional_info?.hide_guard_column) {
                  <th>Guard</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of summaryData; track row; let i = $index) {
                <tr id="section_up{{ i + 1 }}">
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="text-center"
                  >
                    {{ i + 1 }}
                  </td>
                  <td [ngClass]="row?.is_deleted ? 'opacity-25' : ''">
                    <div class="d-flex">
                      <span
                        [ngClass]="
                          eventsOutsideStatusTimeStamps?.includes(row?.id)
                            ? 'text-danger'
                            : ''
                        "
                      >
                        {{ row?.event_time | date: "dd MMM yyyy HH:mm" }}
                      </span>
                    </div>
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    class="text-uppercase line-height"
                  >
                    @if (row?.file_url) {
                      <a
                        class="cursor-pointer"
                        (click)="
                          scrollToSection($event, 'section_down' + (i + 1))
                        "
                        style="color: #00538d"
                      >
                        {{ row?.action }}
                      </a>
                    } @else {
                      {{ row?.action }}
                    }
                  </td>
                  <td
                    [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    style="border-left: hidden"
                  >
                    <div class="d-flex">
                      <div class="gt-multi-line fs-6 enable-text-select">
                        {{ row?.value }}
                      </div>
                      @if (
                        row?.value && [7, 8, 19].includes(row?.event_action)
                      ) {
                        <div>
                          <span (click)="copyContentToClipBoard(row?.value)">
                            <i
                              class="fa-regular fa-copy fs-5 text-secondary ms-3"
                            ></i>
                          </span>
                        </div>
                      }
                    </div>
                  </td>
                  @if (!detailData?.additional_info?.hide_guard_column) {
                    <td
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="line-height"
                    >
                      {{ row?.event_by }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mt-3">
          <tbody>
            @for (row of summaryData; track row; let i = $index) {
              <tr id="section_up{{ i + 1 }}">
                <td class="bg-body-secondary text-body-emphasis">
                  <div class="d-flex justify-content-between">
                    <div
                      class="small text-secondary d-flex"
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                    >
                      <span
                        [ngClass]="
                          eventsOutsideStatusTimeStamps?.includes(row?.id)
                            ? 'text-danger'
                            : ''
                        "
                      >
                        {{ row?.event_time | date: "dd MMM yyyy HH:mm" }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between small text-secondary"
                  >
                    <div
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="text-uppercase line-height"
                    >
                      @if (row?.file_url) {
                        <a
                          class="cursor-pointer"
                          (click)="
                            scrollToSection($event, 'section_down' + (i + 1))
                          "
                          style="color: #00538d"
                        >
                          {{ row?.action }}
                        </a>
                      } @else {
                        {{ row?.action }}
                      }
                    </div>
                    @if (!detailData?.additional_info?.hide_guard_column) {
                      <div
                        [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                        class="line-height"
                      >
                        {{ row?.event_by }}
                      </div>
                    }
                  </div>
                  <div [ngClass]="row?.is_deleted ? 'opacity-25' : ''">
                    <div class="d-flex pt-2">
                      <div class="gt-multi-line fs-6 enable-text-select">
                        {{ row?.value }}
                      </div>
                      @if (
                        row?.value && [7, 8, 19].includes(row?.event_action)
                      ) {
                        <div>
                          <span (click)="copyContentToClipBoard(row?.value)">
                            <i
                              class="fa-regular fa-copy fs-5 text-secondary ms-3"
                            ></i>
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    @if (
      detailData?.additional_info?.show_completed_tasks &&
      completedTasksData?.length
    ) {
      <div class="fw-bold p-2">Completed Tasks</div>
      @if (largeView) {
        <div class="patrol-table mb-5">
          <table class="w-100">
            <thead>
              <tr>
                <th class="text-center">ID</th>
                <th>Time</th>
                <th>Task</th>
                <th style="border-left: hidden"></th>
                @if (!detailData?.additional_info?.hide_guard_column) {
                  <th>Guard</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of completedTasksData; track row; let i = $index) {
                <tr>
                  <td class="text-center">
                    {{ i + 1 }}
                  </td>
                  <td>
                    <div class="d-flex">
                      {{ row?.updated_datetime | date: "dd MMM yyyy HH:mm" }}
                    </div>
                  </td>
                  <td class="gt-multi-line">
                    {{ row?.task }}
                  </td>
                  <td style="border-left: hidden" class="gt-multi-line">
                    {{ row?.value }}
                    @if (row?.prompts?.length) {
                      @for (item of row?.prompts; track item) {
                        <div class="mb-2">
                          @for (dataItem of item?.data; track dataItem) {
                            @if (dataItem?.show_in_reports) {
                              <div>
                                <ng-template
                                  *ngTemplateOutlet="
                                    promptTemplate;
                                    context: { value: dataItem }
                                  "
                                ></ng-template>
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </td>
                  @if (!detailData?.additional_info?.hide_guard_column) {
                    <td
                      [ngClass]="row?.is_deleted ? 'opacity-25' : ''"
                      class="line-height"
                    >
                      {{ row?.event_by }}
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <table class="table table-responsive mt-3">
          <tbody>
            @for (row of completedTasksData; track row; let i = $index) {
              <tr>
                <td class="bg-body-secondary text-body-emphasis">
                  <div class="d-flex justify-content-between">
                    <div class="small text-secondary d-flex">
                      {{ row?.updated_datetime | date: "dd MMM yyyy HH:mm" }}
                    </div>
                    @if (!detailData?.additional_info?.hide_guard_column) {
                      <div class="line-height">
                        {{ row?.event_by }}
                      </div>
                    }
                  </div>

                  <div class="line-height small gt-multi-line">
                    {{ row?.task }}
                  </div>

                  <div class="gt-multi-line fs-6">
                    {{ row?.value }}
                    @if (row?.prompts?.length) {
                      @for (item of row?.prompts; track item) {
                        <div class="mb-2">
                          @for (dataItem of item?.data; track dataItem) {
                            @if (dataItem?.show_in_reports) {
                              <div>
                                <ng-template
                                  *ngTemplateOutlet="
                                    promptTemplate;
                                    context: { value: dataItem }
                                  "
                                ></ng-template>
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    }
    <!-- DETAILS SECTION -->
    <div
      class="mt-3"
      style="box-decoration-break: clone; -webkit-box-decoration-break: clone"
    >
      @for (item of eventData; track item; let i = $index) {
        @if (item?.file_url && !item?.is_deleted) {
          <div id="section_down{{ i + 1 }}">
            <div class="d-flex mb-4">
              <div
                [ngClass]="
                  largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                "
              >
                <!-- @if (item?.download_url) {
                  <a
                    href="{{ item.download_url }}"
                    style="text-decoration: none"
                  >
                    <button class="btn btn-primary btn-sm mb-3">
                      Download Video
                    </button>
                  </a>
                } -->

                <!--TIMESTAMP-->
                <div
                  class="key-value d-flex gap-1 mb-2 fw-semibold"
                  [ngClass]="
                    eventsOutsideStatusTimeStamps?.includes(item?.id)
                      ? 'text-danger'
                      : ''
                  "
                >
                  {{ item?.event_time | date: "dd MMM yyyy HH:mm" }}
                </div>
                <!-- GPS ACCURACY NOTIFICATION-->
                @if (item?.event_gps?.source) {
                  <div class="warning">
                    @switch (item?.event_gps?.source) {
                      @case (1) {
                        Location Accuracy: Low
                      }
                      @case (2) {
                        Location Accuracy: Very Low
                      }
                    }
                  </div>
                }
                <!--SECTION: EVENT LOCATION-->
                @if (item?.event_gps?.lat && item?.event_gps?.lon) {
                  <div style="margin-bottom: 2rem">
                    <div class="key-label text-secondary">Event Location</div>
                    <div
                      style="max-width: 100%; height: 150px; object-fit: none"
                      class="small"
                    >
                      <gtapp-map-leaflet
                        [customMapConfig]="{ showSimpleStaticMap: true }"
                        [latLon]="{
                          markerTooltip: item?.event_by,
                          lat: item?.event_gps?.lat,
                          lon: item?.event_gps?.lon,
                        }"
                        [mapId]="'map_' + i"
                      ></gtapp-map-leaflet>
                    </div>
                  </div>
                }
                <!--SECTION:  PHOTO COMMENT/NOTES-->
                <div class="d-inline">
                  <div class="gt-multi-line">
                    @if (item?.value) {
                      <span>
                        {{ item?.value }}
                        @if (item.value) {
                          <span (click)="copyContentToClipBoard(item.value)">
                            <i
                              class="fa-regular fa-copy fs-5 text-secondary ms-3"
                            ></i>
                          </span>
                        }
                      </span>
                    }
                  </div>
                </div>
              </div>
              <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                @if (
                  [".mp4", ".mov", ".webm", ".mkv"].includes(
                    item?.file_extension
                  ) || item?.download_url
                ) {
                  <video
                    controls
                    style="
                      max-height: 100%;
                      max-width: 100%;
                      display: flex;
                      width: 100%;
                    "
                  >
                    <source
                      [src]="item?.download_url || item?.file_url"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                } @else {
                  <img
                    (click)="onOpenImage($event, item)"
                    src="{{ item?.file_url }}"
                    style="max-height: 100%; max-width: 100%; display: flex"
                  />
                }
              </div>
            </div>
          </div>
        }
      }

      @if (promptFileDataUrls?.length && completedTasksData?.length) {
        @for (promptFile of promptFileDataUrls; track $index) {
          <div [id]="'mobile_form_detail' + promptFile?.file_id">
            <ng-container>
              <div class="d-flex mb-2">
                <div
                  [ngClass]="
                    largeView ? 'w-25 small pe-1 pb-3' : 'w-50 small pe-1 pb-3'
                  "
                >
                  <!--SECTION:  PHOTO COMMENT/NOTES-->
                  <div class="d-inline">
                    <div
                      style="color: #00538d"
                      class="gt-multi-line cursor-pointer text-decoration-underline"
                      (click)="
                        scrollToSection(
                          $event,
                          'mobile_form_summary' + promptFile?.file_id
                        )
                      "
                    >
                      @if (promptFile?.description) {
                        <span>
                          {{ promptFile?.description }}
                        </span>
                      }
                    </div>
                  </div>
                </div>
                <div [ngClass]="largeView ? 'w-75' : 'w-50'">
                  @if (
                    [".mp4", ".mov", ".webm", ".mkv"].includes(
                      promptFile?.file_extension
                    )
                  ) {
                    <video autoplay>
                      <source
                        src="{{ promptFile?.file_url }}"
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  } @else {
                    <img
                      (click)="onOpenImage($event, promptFile)"
                      src="{{ promptFile?.file_url }}"
                      style="max-height: 100%; max-width: 100%; display: flex"
                    />
                  }
                </div>
              </div>
            </ng-container>
          </div>
        }
      }
    </div>
  }
</div>

<ng-template let-dataItem="value" #promptTemplate>
  @if (dataItem?.description) {
    <dl [id]="'mobile_form_summary' + dataItem?.file_id">
      @if (dataItem?.file_id && promptFileDataUrls?.length) {
        <a
          class="cursor-pointer"
          (click)="
            scrollToSection($event, 'mobile_form_detail' + dataItem?.file_id)
          "
          style="color: #00538d"
        >
          <dt class="text-text-uppercase">{{ dataItem?.description }}</dt>
        </a>
      } @else {
        <dt class="text-text-uppercase">{{ dataItem?.description }}</dt>
      }
      <dd>{{ dataItem | misc: "promptValue" }}</dd>
    </dl>
  }
  @for (option of dataItem?.options; track option) {
    <div class="nested-prompt">
      <ng-template
        *ngTemplateOutlet="promptTemplate; context: { value: option }"
      ></ng-template>
    </div>
  }
</ng-template>
